const meta = { auth: true }

export default [
  {
    path: 'index',
    name: 'admin-index',
    component: () => import('./index'),
    meta: {
      ...meta,
      title: '管理首页'
    }
  }
]
